// 审计日志的接口（docs/04 第 8 节 `/api/audit`，表见 docs/03 7.2）。
import { api } from "./api";
import type { ListCount } from "./usePage";

export interface AuditEntry {
  id: number; actor: string; action: string; entity_type: string; entity_id: string;
  before: unknown; after: unknown; remote_ip: string | null; created_at: string;
}

export interface AuditFilter { entity_type?: string; actor?: string; limit?: number; before_id?: number }

/** 按过滤条件读审计记录；path 是审计接口或发送测试的记录接口（后者固定只列 message 实体，D181）。 */
export function auditList(path: string, f: AuditFilter = {}) {
  const q = new URLSearchParams();
  if (f.entity_type) q.set("entity_type", f.entity_type);
  if (f.actor) q.set("actor", f.actor);
  if (f.limit) q.set("limit", String(f.limit));
  if (f.before_id) q.set("before_id", String(f.before_id)); // 游标：只取 id 比它小的（#133）
  const qs = q.toString();
  return api<AuditEntry[]>(qs ? `${path}?${qs}` : path);
}

/** 按过滤条件数审计记录（决策 D182）；path 同 auditList。 */
export function auditCount(path: string, f: Pick<AuditFilter, "entity_type" | "actor"> = {}) {
  const q = new URLSearchParams();
  if (f.entity_type) q.set("entity_type", f.entity_type);
  if (f.actor) q.set("actor", f.actor);
  const qs = q.toString();
  return api<ListCount>(qs ? `${path}/count?${qs}` : `${path}/count`);
}

/** 审计日志只给超级管理员（D181）。 */
export const audit = {
  count: (f: Pick<AuditFilter, "entity_type" | "actor">) => auditCount("/audit", f),
  list: (f: AuditFilter = {}) => auditList("/audit", f),
};

/** 审计动作的展示文案，取值见 docs/04 第 2 节；表里没有的原样显示。 */
export const AUDIT_ACTION: Record<string, string> = { create: "新建", update: "更新", update_secret: "改口令", publish: "发布", topup: "充值", correct: "价格更正", reset: "重置", login: "登录", import: "导入" };
